export const legal = {
  title: 'Legale',
  terms: {
    title: 'Termini di Servizio'
  },
  privacy: {
    title: 'Privacy Policy'
  },
  cookies: {
    title: 'Cookie Policy'
  },
  copyright: '© {{year}} SynthoHosting. Tutti i diritti riservati.'
};